<div class="dialog-title">
  <h2 class="title">
    <mat-icon>layers</mat-icon>
    {{'viewer.zones'|translate}}
  </h2>
  <span class="spacer"></span>

  <app-search-bar (searchText)="search($event)"></app-search-bar>

  <lib-button color="primary" class="menu-item" icon="add" tooltip="{{'viewer.zone.add'|translate}}"
    (click)="createZone()">
  </lib-button>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted" tooltip="{{'viewer.close'|translate}}">
    <mat-icon>close</mat-icon>
  </lib-button>
</div>

<mat-dialog-content>
  <form [formGroup]="zoneForm">
    <table mat-table [dataSource]="dataSource" class="table">

      <!-- checked field Column -->
      <ng-container matColumnDef="display">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-checkbox type="checkbox" [checked]="enableAllzones" (change)="showAllZones($event)"> </mat-checkbox>
            <mat-icon fontIcon="visibility"></mat-icon>
            {{'datatable.display'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <mat-checkbox type="checkbox" [checked]="zone.visible" (change)="showZone($event,zone)"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="layers"></mat-icon>
            {{'datatable.name'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <span *ngIf="zoneId!=zone.id">
            {{zone.name}}
          </span>

          <mat-form-field appearance="outline" *ngIf="isModifyZone && zoneId==zone.id" class="zone-input">
            <mat-label>{{'viewer.modify_zone_name'|translate}}</mat-label>
            <input *ngIf="isModifyZone && zoneId==zone.id" matInput type="text" formControlName="name">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- color Column -->
      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="palette"></mat-icon>
            {{'datatable.color'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <div *ngIf="zoneId!=zone.id" class="color-option">
            <span class="color-circle" [style.background-color]="getColorValue(zone.color)"></span>
            <span class="color-name">{{getColorName(zone.color)}}</span>
          </div>

          <mat-form-field appearance="outline" *ngIf="isModifyZone && zoneId==zone.id" class="zone-input">
            <mat-select formControlName="color">
              <mat-select-trigger>
                <div class="color-option">
                  <span class="color-circle"
                    [style.background-color]="getColorValue(zoneForm.get('color')?.value)"></span>
                  <span class="color-name">{{getColorName(zoneForm.get('color')?.value)}}</span>
                </div>
              </mat-select-trigger>

              <mat-option [value]="color.name.toLowerCase()" *ngFor="let color of listColor">
                <div class="color-option">
                  <span class="color-circle" [style.background-color]="color.value"></span>
                  <span class="color-name">{{color.name}}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- opacity Column -->
      <ng-container matColumnDef="opacity">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="opacity"></mat-icon>
            {{'datatable.alpha'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <div *ngIf="zoneId!=zone.id" class="zone-input-number">
            {{zone.alpha}}
          </div>

          <mat-form-field appearance="outline" *ngIf="isModifyZone && zoneId==zone.id" class="zone-input-number">
            <mat-label>
              {{'datatable.alpha'|translate}}
            </mat-label>

            <input matInput type="number" formControlName="opacity">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- z Column -->
      <ng-container matColumnDef="z">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="layers"></mat-icon>
            {{'viewer.z'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <div *ngIf="zoneId!=zone.id" class="zone-input-number">
            {{zone.z}}
          </div>

          <mat-form-field appearance="outline" *ngIf="isModifyZone && zoneId==zone.id" class="zone-input-number">
            <mat-label>Z</mat-label>
            <input matInput type="number" formControlName="z">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- height Column -->
      <ng-container matColumnDef="height">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="height"></mat-icon>
            {{'geometry.height'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone">
          <div *ngIf="zoneId!=zone.id" class="zone-input-number">
            {{zone.height}}
          </div>

          <mat-form-field appearance="outline" *ngIf="isModifyZone && zoneId==zone.id" class="zone-input-number">
            <mat-label>
              {{'viewer.height'|translate}}
            </mat-label>

            <input matInput type="number" formControlName="height">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-table">
            <mat-icon fontIcon="edit"></mat-icon>
            {{'datatable.actions'|translate}}
          </div>
        </th>

        <td mat-cell *matCellDef="let zone;let index=index">
          <div class="action-btn">
            <lib-button color="none" textColor="primary" icon="save" tooltip="{{'form.save' | translate}}"
              *ngIf="zoneId==zone.id" (click)="setChangesofZone(zone)">
            </lib-button>

            <lib-button color="none" textColor="secondary" icon="edit" tooltip="{{'form.edit' | translate}}"
              *ngIf="zoneId!=zone.id" (click)="modifyZone(zone)">
            </lib-button>

            <lib-button color="none" textColor="secondary" icon="control_camera" tooltip="{{'form.move' | translate}}"
              *ngIf="zoneId==zone.id" (click)="editZone(zone)">
            </lib-button>

            <lib-button color="none" textColor="tertiary" icon="content_copy" tooltip="{{'form.duplicate' | translate}}"
              (click)="duplicateZone(zone)">
            </lib-button>

            <lib-button color="none" textColor="danger" icon="delete" tooltip="{{'form.delete' | translate}}"
              (click)="deleteZone(zone)">
            </lib-button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
          </lib-no-data>
        </td>
      </tr>
    </table>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <lib-button text="{{'viewer.close'|translate}}" color="outline" icon="close" (click)="close()"></lib-button>
</mat-dialog-actions>